<script>
  export let img;
  export let alt;
  export let name;
  export let qty;
</script>
<li>
  <div>
    <img height="70" width="47" src={img} alt="{alt}" />
  </div>
  <b>{qty}</b> {name}{qty == 1? '' : 's'}
</li>
<style>
li {
  display: flex;
  align-items: center;
}
img {
  height: 70px;
  width: auto;
  margin-right: 20px;
}
b {
  margin-right: 5px;
}
div {
  height: 70px;
  width: 47px;
  display: block;
}
</style>